module.exports = __webpack_public_path__ + "static/media/arrow.105b6a33.svg";